import React, { Component } from 'react';
import phase1 from '../../../assets/images/svgs/container/container_phase1.svg';
import phase2 from '../../../assets/images/svgs/container/container_phase2.svg';
import phase3 from '../../../assets/images/svgs/container/container_phase3.svg';
import phase4 from '../../../assets/images/svgs/container/container_phase4.svg';
import phase5 from '../../../assets/images/svgs/container/container_phase5.svg';
import { BackgroundSection } from '../stateless/background-section';


/**
 * @class BackgroundContainers
 *
 * @description
 * Class for the background containers control, this group will
 * control visibility of the assets.
 *
 * @example
 * <BackgroundContainers />
 */
export default class BackgroundContainers extends Component {

	/**
	 * @description
	 * Component Method
	 * Renders a component
	 *
	 * @returns {Component} component
	 */
	render () {
		const { progress } = this.props;
		const phases = [phase1, phase2, phase3, phase4, phase5]

		return <BackgroundSection progress={progress} phases={phases} assets={this.props.assets}/>
	}
}
